import { lazy, Suspense } from 'react';
import { isNotFound } from '@tanstack/react-router';
import { usePortalCampaignQuery } from '@/lib/data-hooks';
import { Image } from '../../-components/image';
import { useCampaignDisplayContext } from './campaign-display-context';

const GalleryContent = lazy(() => import('./campaign-image-gallery-content'));

export function CampaignImageGallery(props: { campaignId: string }) {
	const displayData = useCampaignDisplayContext();
	if (displayData) {
		const { campaign } = displayData;
		if (!campaign.carouselImages || campaign.carouselImages.length === 0) return null;
		return (
			<Suspense fallback={<GalleryFallback />}>
				<GalleryContent
					images={campaign.carouselImages.map((img, index) => ({
						key: img.location,
						alt: img.alt ?? `Campaign gallery ${index + 1}`,
						image: (
							<Image
								src={img.location}
								height={286}
								aspectRatio={413 / 286}
								className="w-full! rounded-2xl object-cover"
								alt={img.alt ?? `Campaign gallery ${index + 1}`}
							/>
						),
					}))}
				/>
			</Suspense>
		);
	}
	return (
		<Suspense fallback={<GalleryFallback />}>
			<SuspensedCampaignImageGallery campaignId={props.campaignId} />
		</Suspense>
	);
}

const galleryPadding = 'max(2.5rem, calc((100% - 1366px) / 2 + 2.5rem))';

function GalleryFallback() {
	return (
		<section className="w-full pb-6">
			<div
				className="flex h-[286px] gap-5 overflow-hidden"
				style={{ paddingLeft: galleryPadding, paddingRight: galleryPadding }}
			/>
		</section>
	);
}

function SuspensedCampaignImageGallery(props: { campaignId: string }) {
	const campaign = usePortalCampaignQuery(props.campaignId);

	if (isNotFound(campaign)) return null;
	if (!campaign.data.carouselImages || campaign.data.carouselImages.length === 0) return null;

	return (
		<GalleryContent
			images={campaign.data.carouselImages.map((img, index) => ({
				key: img.location,
				alt: img.alt ?? `Campaign gallery ${index + 1}`,
				image: (
					<Image
						src={img.location}
						height={286}
						aspectRatio={413 / 286}
						className="w-full! rounded-2xl object-cover"
						alt={img.alt ?? `Campaign gallery ${index + 1}`}
					/>
				),
			}))}
		/>
	);
}
